
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const DhandhraulDam=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Dhandhraul Dam</h1>
           <p className="sub-heading">A serene reservoir on the Ghaghar River, offering picturesque views and vital water resources in Sonbhadra</p>
         </div>
         <div className="description">
         Dhanraul Dam is also known as Dhandhraul Dam. It is located about 23 km from Robertsganj on the Robertsganj-Churk road, in Sonbhadra district, Uttar Pradesh, India. The dam was constructed over the river Ghaghar and water from its reservoir is used for irrigation by the canals originating from here like Ghaghar canal to the nearer districts Mirzapur, Chandauli and Sonbhadra. Dhanraul Dam's water supplies Robertsganj with drinking water. This dam is constructed on the Ghaghar River and is also called Ghaghar Dam.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam10.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam6.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam7.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam8.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam9.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam11.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dhandharoul Dam/dam12.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
         </div>
   
         <BookSection />
       </div>
     );
};